import React from 'react'
import Button from '../button'
import UnlockPremimumButton from '../unlock-premium-button'

const SourceSelector = ({ type, className, titleImgSrc, title, textContents=[], onClick, disable, imgSrc, label, showUnlockPremiumButton, btnType }) => {
  return (
    <div className={`bimmatch-source-selector source-type-${type} ${className}`}>
        <div className="title">
            {titleImgSrc && <img src={titleImgSrc} alt="title" className="autodesk-icon" />}
            <h3>{title}</h3>
        </div>
        {textContents.map((content, index) => (
            <p key={index}>{content}</p>
        ))}
        <Button onClick={onClick} disable={disable} type={btnType}>
            {imgSrc && <img src={imgSrc} alt="button" />}
            {label}
        </Button>
        {showUnlockPremiumButton && <UnlockPremimumButton />}
    </div>
  )
}

export default SourceSelector